import Interweave from 'interweave'
import PropTypes from 'prop-types'
import Section from '../../Section'
import { parseTableFormat } from './utils'

const OperationalSecurityChecklists = ({ report: { reportContent } }) => (
  <Section title="Operational Security Checklists">
    <div className="operational-security-checklists-container">
      <Interweave
        content={parseTableFormat(reportContent.summary.operationalSecurityChecklists, true)}
      />
    </div>
  </Section>
)

OperationalSecurityChecklists.propTypes = {
  report: PropTypes.object,
}

export default OperationalSecurityChecklists
